export default __webpack_public_path__ + "static/media/potential-outage-secondary-bg.e48cecd6.jpg";